/**
 * usage $Fabric.getCode(<fabric_id>);
 * example $Fabric.getCode(10021) => result 21
 * this function can call from anywhere in vue pages
 */


const CONTRAST_FABRIC_NAME_PREFIX = 'K';
const JERSEY_FABRIC_NAME_PREFIX   = 'J';
const TENCEL_FABRIC_NAME_PREFIX   = 'T';
const OEM_FABRIC_NAME_PREFIX = 'OEM-';
const OEM_FABRIC_ID_START = 60000;
class Fabric {

    // this function is to change fabric id into production code
    getCode(id) {

        if(id >= OEM_FABRIC_ID_START) {
          return OEM_FABRIC_NAME_PREFIX + (id % OEM_FABRIC_ID_START)
        }

        id = id + '';
        if (id.charAt(0) * 1 === 1) {
            return id % 10000;
        }
        else if (id.charAt(0) * 1 === 2) {
            var prefix = (id === 20500) ? TENCEL_FABRIC_NAME_PREFIX : JERSEY_FABRIC_NAME_PREFIX;
            return prefix + (id % 20000);
        }
        else if (id.charAt(0) * 1 === 3) {
            return CONTRAST_FABRIC_NAME_PREFIX + (id % 30000)
        }
        else {
            return id;
        }
    }

    // this function is to change production code into fabric Id
    getId(code) {
        var code = code + '';
        if (code.startsWith(OEM_FABRIC_NAME_PREFIX)) {
          let id = code.substring(OEM_FABRIC_NAME_PREFIX.length);
          return OEM_FABRIC_ID_START + (id * 1)
        }
        var prefix = code.charAt(0).toUpperCase();

        if (prefix === CONTRAST_FABRIC_NAME_PREFIX) {
            let id = code.substring(1);
            return 30000 + (id * 1)
        }
        else if (prefix === TENCEL_FABRIC_NAME_PREFIX || prefix === JERSEY_FABRIC_NAME_PREFIX) {
            let id = code.substring(1);
            return 20000 + (id * 1)
        }
        else {
            code = (code * 1)
            return code >= 10000 ? code : 10000 + code
        }
    }

    getFormattedCompositionLabels(compositionLabels) {
        let formattedCompositionLabels = [];
        for (let index in compositionLabels) {
            let data = compositionLabels[index];
            let formattedName = this.formatCompositionLabel(data);
            formattedCompositionLabels.push({ id: data.id, name: formattedName });
        }
        return formattedCompositionLabels;
    }

    formatCompositionLabel(data) {
        let components = [];
        if (data.fiber_1.length) {
            components.push(`${data.fiber_1} ${data.fiber_1_percentage}`);
        }
        if (data.fiber_2 !== null && data.fiber_2.length) {
            components.push(`${data.fiber_2} ${data.fiber_2_percentage}`);
        }
        if (data.fiber_3 !== null && data.fiber_3.length) {
            components.push(`${data.fiber_3} ${data.fiber_3_percentage}`);
        }
        return components.join('%, ') + '%';
    }

    getFabricSystemRoles() {
        return ['super_admin', 'admin', 'fabric_production_staff']
    }

    getFabricInventoryRoles() {
        return ['fabric_inventory']
    }

    isFabricSystemUser(user) {
        if(Array.isArray(user.role)) {
            const fabricRoles = this.getFabricSystemRoles().filter(element => user.role.includes(element));
            return fabricRoles.length > 0;
        }
        return this.getFabricSystemRoles().includes(user.role);
    }

    isFabricInventoryUser(user) {
        if(Array.isArray(user.role)) {
            const fabricRoles = this.getFabricInventoryRoles().filter(element => user.role.includes(element));
            return fabricRoles.length > 0;
        }
        return this.getFabricInventoryRoles().includes(user.role);
    }
}

let app = new Fabric;
export default app;
export { OEM_FABRIC_ID_START }
